module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_4.a35dc692.png";